<script>
/* eslint-disable */ 
import { HMIS_USERNAME } from "@/plugins/vars";
import { rights } from "@/plugins/rights";
import routes from "@/router/routes";
export default {
    name: "NavBar",

    data() {

        return {

            profileDropdown: false
        };
    },

    computed: {

        rights() {
            const filterRoutes = routes.filter(route => route.meta && route.meta.permissions);
            
            return [
                ...rights,
                ...filterRoutes.map(route => {
                        return {
                            pageName: route.meta.permissions.PageName,
                            pageDescription: route.meta.permissions.PageDescription,
                        };
                }),
            ];      
        },
    },

    methods: {

        logOut() {

            window.Cookies.remove(HMIS_USERNAME);
            window.Cookies.remove("P_102");
            window.localStorage.removeItem("P_102");
            window.localStorage.removeItem("P_103");
            window.localStorage.removeItem("P_104");
            window.location.replace('/login');
        },
        ToHr() {
            window.location.href = 'https://hmis.radiocarehospital.com:55';

},
        registerRights() {
            

            const rights =  {
                systemRightsPage: this.rights
            };
            this.$root.loading=true;
            this.$http.post(`Admin/RegisterSystemPages`, rights).then(() => {
                this.$root.loading=false;
            }).catch(() => { this.$root.loading=false; });
        },
    },
}
</script>
<template>
<nav id="nav" class="bg-gray-900 p-tiny px-1 mt-0 h-auto fixed w-full z-20 top-0">
    <div class="flex flex-wrap items-center">
        <div class="flex flex-1 md:w-1/3 text-white">
            <a href="javascript:void(0)">
                <span class="text-base text-center pl-3 mr-1">HMIS</span>
            </a>
        </div>
            <div class="flex w-full content-center justify-between md:w-1/3 md:justify-end">
                <ul class="list-reset flex md:justify-between flex-1 md:flex-none md:items-center 
                    justify-end">
                    <li class="flex-3 md:flex-none md:mr-3">
                		<div class="relative sm:ml-10 inline-block">
                			<button  v-if="$root.checkAuth('ViewPendingLabInvestigationsCounts')" 
                                class="btn-sm btn-warning  rounded uppercase text-sm focus:outline-none"> 
                              Pending Lab Queue({{ $root.pendingLabQueue }})</button>
                              <button  v-if="$root.checkAuth('ViewPendingRadiologyInvestigationsCounts')" 
                                class="btn-sm bg-blue-400  rounded uppercase text-sm focus:outline-none"> 
                              Pending Radiology Queue({{ $root.pendingRadiologyQueue }})</button>
                                    <button @click.prevent="profileDropdown = !profileDropdown" 
                                class="drop-button text-white uppercase text-sm focus:outline-none"> 
                                {{ $root.username }} <i class="fa fa-user"></i>
                                    <i class="fas fa-caret-down"></i></button>
                            <div id="myDropdown" class="dropdownlist w-40 absolute bg-gray-900 
                                text-white right-0 mt-1 p-3 overflow-auto z-30" 
                                v-if="profileDropdown">
                                <button @click.prevent="$router.push({name: `profile.appointments.index`})"
                                    class="p-2 w-full hover:bg-gray-800 text-white text-sm 
                                    no-underline hover:no-underline block">
                                        <i class="fa fa-tasks fa-fw"></i> Appointments</button>
                                <button @click.prevent="$router.push({name: `profile.statement.index`})"
                                    class="p-2 w-full hover:bg-gray-800 text-white text-sm 
                                    no-underline hover:no-underline block">
                                        <i class="fa fa-list fa-fw"></i> Statement</button>
                                <button 
                                    @click.prevent="registerRights"
                                    class="p-2 w-full hover:bg-gray-800 text-white text-sm 
                                    no-underline hover:no-underline block">
                                        <i class="fa fa-cog fa-fw"></i> Settings</button>
                                        <button  v-if="$root.checkAuth('HRAccess')"  @click.prevent="ToHr" class="p-2 w-full hover:bg-gray-800 
                                    text-white text-sm no-underline hover:no-underline block">
                                        <i class="fa fa-users"></i> HR</button>
                                <button @click.prevent="logOut" class="p-2 w-full hover:bg-gray-800 
                                    text-white text-sm no-underline hover:no-underline block">
                                        <i class="fas fa-sign-out-alt fa-fw"></i> Log Out</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
    </div>
</nav>
</template>

